window.addEventListener('load', event => {
    let multipageContentPanel = document.querySelector('.form-content-container');

    if (multipageContentPanel) {
        let formRevealButtons = multipageContentPanel.querySelectorAll('.start-quiz-button');

        for (let button of formRevealButtons) {
            button.addEventListener('click', event => {
                let parentPanel = button.closest('.multipage-form-panel');
                let contentContainer = parentPanel.querySelector('.form-content-container');
                let formContainer = parentPanel.querySelector('.form-container');

                contentContainer.classList.add('opacity-0', 'blur-lg', '-translate-x-full');
                formContainer.classList.remove('pointer-events-none','select-none', 'opacity-0', 'blur-lg','translate-x-full');
                setTimeout(() => {
                    contentContainer.classList.add('!hidden');
                }, 500);
                setTimeout(() => {
                    formContainer.classList.remove('absolute', 'top-8', 'lg:top-10', 'inset-x-0' ,'px-6', 'lg:px-8');
                }, 550);
            });
        }
    }
});